import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { TeilgebietSelectionService } from '../../service/common/teilgebiet/teilgebiet-selection.service';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { NetzzuordnungSnapshot } from '../../domain/model/netzzuordnung-snapshot';
import { Router } from '@angular/router';
import { NetzzuordnungFilter } from '../../service/netzzuordnung/netzzuordnung-filter';
import moment from 'moment';
import { RoutingService } from '../../service/common/routing/routing.service';

@Component({
    selector: 'redispatch-dashboard-uuid-change-confirmation',
    templateUrl: './dashboard-uuid-change-confirmation.component.html',
    styleUrls: [
        './dashboard-uuid-change-confirmation.component.scss',
    ],
    standalone: false,
})
export class DashboardUuidChangeConfirmationComponent {

    @Input()
    public snapshot: NetzzuordnungSnapshot | null = null;

    private router = inject(Router);
    private routeService = inject(RoutingService);
    private netzbetreiberService = inject(NetzbetreiberService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public updateLastUuidChangeConfirmDate() {
        this.netzbetreiberService.updateLastUuidChangeConfirmDate(
            this.teilgebietSelectionService.getSelectedStadtwerkeId(),
            new Date(),
        ).subscribe(snapshot => {
            this.snapshot = snapshot;
            this.changeDetectorRef.markForCheck();
        });
    }

    public routeToNetzzuordnungPage() {
        let filter: NetzzuordnungFilter = {
            stadtwerkeId: this.teilgebietSelectionService.getSelectedStadtwerkeId(),
        };
        if (this.snapshot && this.snapshot.numberOfUnconfirmedNetzzuordnungen > 0) {
            const date = moment(this.snapshot.lastConfirmedUuidDate || null); // undefined means now
            filter.uuidDateStart = date.isValid() ? date : undefined;
        }
        this.router.navigateByUrl(this.routeService.netzzuordnungTable(null, filter));
    }

}
